import * as zod from 'zod';

import { DeviceCommand } from '@sb/integrations/types';
import { PayloadState } from '@sb/routine-runner/types/PayloadState';

// Marker for deviceID cleared by import sanitization; treated as no selection.
export const MISSING_DEVICE_MARKER = '[MISSING_DEVICE]';

export const ActuateGripperArguments = zod.object({
  gripperCommand: DeviceCommand,
  payload: PayloadState.optional(),
  retry: zod.boolean().optional(),
  stopRoutineOnFailure: zod.boolean(),
  deviceID: zod.string().optional(),
  deviceKind: zod.string().optional(),
});

export type ActuateGripperArguments = zod.infer<typeof ActuateGripperArguments>;
